// AnimatedEllipsis — "…" that types itself in one dot at a time and resets,
// matching the cadence of a typical fetch (~1–2 cycles before data lands).
// The keyframes + reduced-motion fallback live in [`styles/global.css`].
//
// Render it inline at the end of loading copy:
//   <>Laddar lag<AnimatedEllipsis /></>
//
// The dots are aria-hidden — the surrounding text already carries the
// "loading" semantics; screen readers don't need to know about the dots.
export function AnimatedEllipsis() {
  return (
    <span className="loading-ellipsis" aria-hidden>
      <span>.</span>
      <span>.</span>
      <span>.</span>
    </span>
  );
}
